import { Colors } from '@banhala/ui-kit';
import type { LikeTabsData } from './types';

export const LIKE_TABS: LikeTabsData = {
  selected_id: 'goods',
  item_list: [
    {
      id: 'goods',
      name: '상품',
      screen_name: 'LIKED_GOODS',
      render: {
        selected_color: Colors.content_primary,
        unselected_color: Colors.content_secondary,
      },
      type: 'CUSTOM',
      default_query: null,
    },
    {
      id: 'folder',
      name: '내 서랍',
      screen_name: 'LIKED_FOLDER',
      render: {
        selected_color: Colors.content_primary,
        unselected_color: Colors.content_secondary,
      },
      type: 'CUSTOM',
      default_query: null,
    },
    {
      id: 'market',
      name: '마켓',
      screen_name: 'NEW_FAVORITED',
      render: {
        selected_color: Colors.content_primary,
        unselected_color: Colors.content_secondary,
      },
      type: 'CUSTOM',
      default_query: null,
    },
    {
      id: 'style',
      name: '코디',
      screen_name: 'LIKED_CODI',
      render: {
        selected_color: Colors.content_primary,
        unselected_color: Colors.content_secondary,
      },
      type: 'WEBVIEW',
      default_query: {
        url: 'https://m.a-bly.com/content/style/zzim',
      },
    },
  ],
};
